/** 截取本地首帧的最长等待，避免坏文件卡住上传。 */
const POSTER_CAPTURE_TIMEOUT_MS = 8_000;
/**
 * 从本地视频地址截取一帧，生成只在本次页面有效的图片地址。
 * 失败或超时返回空，不抛错，上传本身继续。
 * @param src 浏览器本地视频地址
 * @returns 首帧对象地址；截不到时为空
 */
export function captureLocalVideoPoster(src) {
    return new Promise((resolve) => {
        /** 用来解码一帧的隐藏视频，不挂到页面上。 */
        const video = document.createElement('video');
        /** 是否已经结算，避免超时和成功同时回调。 */
        let settled = false;
        /** 超时计时器。 */
        const timer = window.setTimeout(() => {
            finish(null);
        }, POSTER_CAPTURE_TIMEOUT_MS);
        /**
         * 结束截帧并释放视频元素。
         * @param url 截到的图片地址
         */
        function finish(url) {
            if (settled)
                return;
            settled = true;
            window.clearTimeout(timer);
            video.pause();
            video.removeAttribute('src');
            video.load();
            resolve(url);
        }
        video.muted = true;
        video.preload = 'auto';
        video.addEventListener('loadeddata', () => {
            /** 视频原始像素尺寸；还没解码出画面时不能画到画布。 */
            const width = video.videoWidth;
            const height = video.videoHeight;
            if (width <= 0 || height <= 0) {
                finish(null);
                return;
            }
            /** 承接这一帧的画布，尺寸与视频一致。 */
            const canvas = document.createElement('canvas');
            canvas.width = width;
            canvas.height = height;
            /** 画布上下文；浏览器不提供时放弃这一帧。 */
            const context = canvas.getContext('2d');
            if (!context) {
                finish(null);
                return;
            }
            context.drawImage(video, 0, 0, width, height);
            canvas.toBlob((blob) => {
                finish(blob ? URL.createObjectURL(blob) : null);
            }, 'image/jpeg');
        });
        video.addEventListener('error', () => {
            finish(null);
        });
        video.src = src;
    });
}
